module.exports = __webpack_public_path__ + "img/benchmarking.9ece9404.svg";